<template>
  <div>
    <div
      v-for="(page, pageIndex) in pageGroupedElements"
      :key="'page-' + pageIndex"
      class="position-relative dinA4"
    >
      <img
        :src="require('@/assets/peninsular-header.png')"
        class="mb-0 page__header"
      />

      <div class="page__container">
        <div
          v-for="(element, elementIndex) in page"
          :key="'element-' + elementIndex"
          style="position: relative; z-index: 100;"
        >
          <div
            v-if="element.type === 'table'"
            class="d-flex justify-center"
            style="width: 100% !important;"
          >
            <PdfProductTable
              type="peninsular"
              :tableData="productTableList[element.id]"
              :tableId="element.id"
              :image="element.imageUrl"
              :descKey="getProduct(element.id).desc_key"
            />
          </div>

          <div
            v-else-if="element.type === 'text'"
            class="d-flex justify-center mb-10"
          >
            <div class="small-letter-section" style="width: 100% !important;">
              <p class="small-letter-font small-letter-font--bold mb-0">
                {{ element.title }}
              </p>
              <ul class="small-letter-font">
                <li
                  v-for="(listElement, listIndex) in element.list"
                  :key="'listElement-' + listIndex"
                  v-html="listElement"
                ></li>
              </ul>
            </div>
          </div>
        </div>
        <div v-if="pageIndex === pageGroupedElements.length - 1" class="note-section mt-10">
          <p class="small-letter-font justify-text" v-html="$t('NOTE_PENINSULAR')"></p>
        </div>
      </div>  
      <Footer :logo="true" :page="previousPages + 1 + pageIndex" />
    </div>
  </div>
</template>




<script>
import { mapGetters } from 'vuex'
import {
  GET_PDF_PRODUCT_TABLE_LIST,
  GET_PRODUCT,
  GET_OFFER_ITEM
} from '@/store/modules/offer/getters'
import PdfProductTable from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-pt-nexus/PdfProductTable'
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-pt-nexus/Footer'

export default {
  name: 'PeninsularTables',
  components: {
    PdfProductTable,
    Footer
  },
  data() {
    return {
      elements: [
        {
          type: 'table',
          imageUrl: require('@/assets/ctt10-icon.png'),
          id: 'C10'
        },
        {
          type: 'text',
          title: 'Características do serviço CTT 10h:',
          list: [
            '• <b>Oferta:</b> B2B; <b>Produto:</b> CTT 10h (10H); <b>Fluxo:</b> PT Continente > PT Continente.',
            '• <b>Peso máximo por volume:</b> 30 kg.',
            '• <b>Medidas máximas por volume:</b> A soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
            '• <b>Medidas mínimas por volume:</b> Comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
            '• <b>Cubicagem:</b> Conversão volumétrica de 167 kg/m3 (meio de transporte terrestre).',
            '• <b>Serviços Adicionais CTT 10h (10H):</b> Cobrança, Proteção Extra, Back, DDA, Frágil (Portugal Continental), SMS.'
          ]
        },
        {
          type: 'table',
          imageUrl: require('@/assets/ctt-14h-icon.png'),
          id: 'C14'
        },
        {
          type: 'text',
          title: 'Características do serviço CTT 14h:',
          list: [
            '• <b>Oferta:</b> B2B; <b>Produto:</b> CTT 14h (13h), CTT 14hM (13M); <b>Fluxo:</b> PT Continente > PT Continente.',
            '• <b>Peso máximo por volume:</b> 30 kg.',
            '• <b>Medidas máximas por volume:</b> A soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
            '• <b>Medidas mínimas por volume:</b> Comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
            '• <b>Cubicagem:</b> Conversão volumétrica a definir de acordo com o meio de transporte utilizado.',
            '• <b>Serviços Adicionais CTT 14h (13H):</b> Cobrança, Proteção Extra, Back, DDA, Frágil (Portugal Continental), SMS, Sábado (Portugal Continental) / <b>CTT 14hM (13M):</b> Cobrança, Proteção Extra, DDA, Frágil (Portugal Continental), SMS, Sábado (Portugal Continental).'
          ]
        },
        {
          type: 'table',
          imageUrl: require('@/assets/ctt24-icon.png'),
          id: 'C24'
        },
        {
          type: 'text',
          title: 'Características do Produto CTT 24h (19H):',
          list: [
            '• <b>Oferta:</b> B2B; <b>Produto:</b> CTT 24h (19H), 24hM (19M); <b>Fluxo:</b> PT Continente > PT Continente; PT Continente > ES Península.',
            '• <b>Peso máximo por volume:</b> 30 kg.',
            '• <b>Medidas máximas por volume:</b> A soma da altura, largura e comprimento não deve exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
            '• <b>Medidas mínimas por volume:</b> Comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
            '• <b>Cubicagem:</b> Conversão volumétrica de 167 kg/m3 (meio de transporte terrestre).',
            '• <b>Serviços Adicionais CTT 24h (19H):</b> Cobrança, Proteção Extra, Back, DDA, Frágil (Portugal Continental), SMS, Sábado (Portugal Continental) / <b>CTT 24hM (19M):</b> Cobrança, Proteção Extra, DDA, Frágil (Portugal Continental), SMS, Sábado (Portugal Continental).'
          ]
        },
        {
          type: 'table',
          imageUrl: require('@/assets/ctt48-icon.png'),
          id: 'C48'
        },
        {
          type: 'text',
          title: 'Características do Produto 48h:',
          list: [
            '• <b>Oferta:</b> B2B; <b>Produto:</b> CTT 48h (48H); <b>Fluxo:</b> PT Continente > PT Continente; PT Continente > ES Península.',
            '• <b>Peso máximo por volume:</b> 30 kg.',
            '• <b>Medidas máximas por volume:</b> A soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
            '• <b>Medidas mínimas por volume:</b> Comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
            '• <b>Cubicagem:</b> Conversão volumétrica de 167 kg/m3 (meio de transporte terrestre).',
            '• <b>Serviços Adicionais CTT 48h (48H):</b> Cobrança, Proteção Extra, Back, DDA, Frágil (Portugal Continental), SMS, Sábado (Portugal Continental).'
          ]
        },
        {
          type: 'table',
          imageUrl: require('@/assets/para-amanha-icon.png'),
          id: 'CE24'
        },
        {
          type: 'text',
          title: 'Características do serviço CTT e24h:',
          list: [
            '• <b>Oferta:</b> B2C; <b>Produto:</b> CTT e24h (Para Amanhã); <b>Fluxo:</b> PT Continente > PT Continente; PT Continente > ES Península.',
            '• <b>Oferta:</b> B2C; <b>Produto:</b> Devolução Fácil; <b>Fluxo:</b> PT Continente > PT Continente; ES Península > PT Continente.',
            '• <b>Peso máximo por volume:</b> 30 kg.',
            '• <b>Medidas máximas por volume:</b> A soma da altura, largura e comprimento não deve exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
            '• <b>Medidas mínimas por volume:</b> Comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
            '• <b>Cubicagem:</b> Conversão volumétrica de 167 kg/m3 (meio de transporte terrestre).',
            '• <b>Serviços Adicionais CTT e24h (Para Amanhã):</b> Cobrança, Proteção Extra, Back, DDA, Frágil (Portugal Continental), Janelas de Entrega (Portugal Continental), Entrega Conjunta, Alteração Dados da Encomenda, Tentativas de Entrega, Entrega em Ponto Collectt (A maior rede de pontos Ibérica).',
            '• <b>Serviços Adicionais Devolução Fácil:</b> Proteção Extra.'
          ]
        },
        {
          type: 'table',
          imageUrl: require('@/assets/em-dos-dias-icon.png'),
          id: 'CE48'
        },
        {
          type: 'text',
          title: 'Características do serviço CTT e48h:',
          list: [
            '• <b>Oferta:</b> B2C; <b>Produto:</b> CTT e48h (Em 2 Dias); <b>Fluxo:</b> PT Continente > PT Continente; PT Continente > ES Península.',
            '• <b>Peso máximo por volume:</b> 30 kg.',
            '• <b>Medidas máximas por volume:</b> A soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
            '• <b>Medidas mínimas por volume:</b> Comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
            '• <b>Cubicagem:</b> Conversão volumétrica de 167 kg/m3 (meio de transporte terrestre).',
            '• <b>Serviços Adicionais CTT e48h (Em 2 Dias):</b> Cobrança, Proteção Extra, Tentativas de Entrega, Alteração Dados da Encomenda, Entrega Conjunta, Entrega em Ponto Collectt (A maior rede de pontos Ibérica).'
          ]
        },
      ],
      previousPages: 0
    }
  },

  computed: {
    ...mapGetters('offer', [
      GET_PDF_PRODUCT_TABLE_LIST,
      GET_PRODUCT,
      GET_OFFER_ITEM
    ]),
    productTableList() {
      return this[GET_PDF_PRODUCT_TABLE_LIST]
    },

    selectedElements() {
      const filtered = []
      for (let i = 0; i < this.elements.length; i++) {
        const el = this.elements[i]

        if (el.type === 'table') {
          const tableId = el.id

          if (this.hasTableData(tableId) && this.isProductSelected(tableId)) {
            filtered.push(el)

            const nextEl = this.elements[i + 1]
            if (nextEl && nextEl.type === 'text') {
              filtered.push(nextEl)
            }
          }
        }
      }
      return filtered
    },
    pageGroupedElements() {
      const pages = []
      const elems = this.selectedElements
      let i = 0

      while (i < elems.length) {
        const tableElement = elems[i]
        const textElement = elems[i + 1]?.type === 'text' ? elems[i + 1] : null

        const rowCount = this.getRowCount(tableElement.id)

        if (rowCount >= 7) {
          pages.push(textElement
            ? [tableElement, textElement]
            : [tableElement]
          )
          i += textElement ? 2 : 1
        } else {
          const currentSet = [tableElement]
          if (textElement) currentSet.push(textElement)
          i += textElement ? 2 : 1

          const nextTable = elems[i]
          const nextText = elems[i + 1]?.type === 'text' ? elems[i + 1] : null

          if (nextTable && nextTable.type === 'table') {
            const nextRowCount = this.getRowCount(nextTable.id)
            if (nextRowCount < 7) {
              currentSet.push(nextTable)
              if (nextText) {
                currentSet.push(nextText)
              }
              i += nextText ? 2 : 1
            }
          }
          pages.push(currentSet)
        }
      }

      return pages
    }
  },

  methods: {
    hasTableData(tableId) {
      const tableData = this.productTableList[tableId]
      return !!(tableData && tableData.kgRows)
    },

    getRowCount(tableId) {
      const tableData = this.productTableList[tableId]
      if (!tableData || !tableData.kgRows) return 0
      return Object.keys(tableData.kgRows).length
    },
    isProductSelected(tableId) {
      const product = this[GET_PRODUCT](tableId)
      return product?.isPreSelected === true
    },
    getProduct(productId) {
      const product = this[GET_PRODUCT](productId);
      return product;
    },
  },

  created() {
    this.$emit('updateTotalPages', {
      PeninsularTables: this.pageGroupedElements.length
    })
  },

  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('PeninsularTables')
  }
}
</script>
